export default "__VITE_ASSET__d5799c35__"